
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";

/**
 * ItemUdfService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemUdfService {
    private readonly $apiService = inject(ApiService);
    
    GetItemUdfMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IItemUdfService/GetItemUdfMetadata");
    }
    GetItemUdfs(pItemId: string, filterString?: string): Promise<any[]> {
        return this.$apiService.sendAuth("IItemUdfService/GetItemUdfs", pItemId, filterString);
    }
    SaveUdfs(pItemUdfs: any): Promise<boolean> {
        return this.$apiService.sendAuth("IItemUdfService/SaveUdfs", pItemUdfs);
    }
}
